const arrToLLObj = arr => ({lat: arr[0], lng: arr[1]});

export default arrToLLObj;
